import Duck from 'custom-redux-ducks-ts'

export const profiles = new Duck('profiles', 'eduprivada')
